import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const ToolsCard = ({ tool }) => {
  const { t } = useTranslation();
  return (
    <div className="p-8 space-y-5 text-center bg-white shadow-mainShadow rounded-2xl min-h-[327px] flex flex-col items-center justify-center">
      <span>{tool.icon}</span>
      <h2 className="text-[20px] font-bold">{tool.header}</h2>
      <p className="text-mainGray">{tool.description}</p>
      <Link className="font-bold text-mainRed underline-link" to={tool.link}>
        {t("readMore")}
      </Link>
    </div>
  );
};

export default ToolsCard;
